
import { Loader2 } from "lucide-react";

interface LoadingStatesProps {
  loading?: boolean;
  redirecting?: boolean;
}

export const LoadingStates = ({ loading, redirecting }: LoadingStatesProps) => {
  // Loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary mr-2" />
        <p>Loading...</p>
      </div>
    );
  }

  // Redirecting state
  if (redirecting) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <Loader2 className="h-10 w-10 animate-spin text-primary mb-4" />
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Redirecting to Dashboard</h2>
        <p className="text-gray-600">Your subscription has been activated...</p>
      </div>
    );
  }

  return null;
};
